import HeaderLeft from '../../../components/Header/HeaderLeft';

export default function PrecisionSectionHeader() {
  
  return (
<>

    <HeaderLeft
        
      headerleft = {'Genetics & Microbiome 360'}

    />
      
   

</>
   )
}